module.exports = __webpack_public_path__ + "img/6.2bfea1ca.jpg";